import styled from 'styled-components';

export const Scrollbar = styled.div`
  height: 87vh;
  ::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #f5f5f5;
  }
  ::-webkit-scrollbar-thumb {
    background: #f5f5f5;
  }
`;

export const BoxPadding = styled.div`
  padding: 0px 20px;
`;
